export const toKebabCase = (str: string): string => {
  return str
    .trim()
    .replace(/^[^a-z]+|[^a-z]+$/gi, '') // Remove non-alphabetic characters from the beginning and end
    .replace(/([a-z])([A-Z])/g, '$1-$2') // Add a hyphen between lowercase and uppercase letters
    .replace(/[\s_]+/g, '-') // Replace spaces and underscores with hyphens
    .toLowerCase();
};
